<template>
<moo-dialog custom-class="common-dialog folder-dialog" :append-to-body="true" :title="$t('确定删除？#!!!#src/pages/H5/Cloud/components/dialog/deleteDialog.vue_1')" :visible.sync="visible" width="480px" :before-close="() => handleDeleteDialog(false)">
        <div class="content">
            <div class="tip">{{$t("删除后可在回收站找回#!!!#src/pages/H5/Cloud/components/dialog/deleteDialog.vue_1")}}</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <moo-button class="cancel" @click="visible = false">{{$t("取 消#!!!#src/pages/H5/Cloud/components/dialog/deleteDialog.vue_1")}}</moo-button>
            <moo-button class="submit" type="primary" @click="handleDeleteFolder">{{$t("确 定#!!!#src/pages/H5/Cloud/components/dialog/deleteDialog.vue_1")}}</moo-button>
        </span>
    </moo-dialog>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { deleteFile } from '@/api/h5/file';
import { debounce } from '@/utils/lodash';

export default {
  props: {
    folderPath: {
      type: String,
      default: ''
    }
  },
  name: 'DeleteDialog',
  components: {
  },
  data() {
    return {
      visible: false,
      folderName: '',
      data: null
    };
  },
  methods: {
    handleDeleteDialog(value, item) {
      this.visible = value;
      this.data = item;
      if (value) {
        this.folderName = item.fileName;
      } else {
        this.folderName = '';
      }
    },
    handleDeleteFolder: debounce(async function () {
      try {
        const { code, message, data = {} } = await deleteFile({ fileIds: [this.data?.fileId] });
        if (code == 200) {
          this.$emit('refresh');
          this.$emit('goHome');
          this.$message({ message: intl.$t("删除成功#!!!#src/pages/H5/Cloud/components/dialog/deleteDialog.vue_1"), type: 'success' });
          this.handleDeleteDialog(false);
        } else {
          this.$message({ message, type: 'error' });
        }
      } catch {
        this.$message({ message: intl.$t("删除失败#!!!#src/pages/H5/Cloud/components/dialog/deleteDialog.vue_1"), type: 'error' });
      }
    })
  },
  computed: {
    path() {
      return this.folderPath + '/' + this.folderName;
    }
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {

  }
};
</script>

<style lang="scss">
.common-dialog {
    border-radius: 8px !important;

    .moo-dialog__header {
        display: block !important;
        font-size: 17px;
        color: #000;
        font-weight: 500;
        box-shadow: 0 0.5px rgba(0, 0, 0, .11);
    }

    .moo-dialog__footer {
        height: 50px;
        box-shadow: 0 -0.5px rgba(0, 0, 0, .11);

        .dialog-footer {
            .cancel {
                outline: none;
                padding: 0;
                color: #222329;
                background: #fff;
                border: 1px solid #e8e9ee;
                font-size: 14px;
                font-weight: 400;
                height: 30px;
                width: 100px;
                border-radius: 4px;
            }

            .submit {
                outline: none;
                color: #fff;
                background: #5c70ff;
                border: none;
                box-shadow: inset -0.5px 0.5px rgba(0, 0, 0, .3), inset 0.5px -0.5px rgba(0, 0, 0, .3);
                font-size: 13px;
                font-weight: 400;
                padding: 0;
                height: 30px;
                width: 100px;
                border-radius: 4px;
            }
        }
    }
}

.folder-dialog {
    .moo-dialog__body {

        .content {
            display: flex;
            flex-flow: column;
            width: 100%;

            .tip {
                margin-top: 2px;
                font-size: 14px;
            }
        }
    }
}

.common-input {
    display: block;
    flex: 1;

    input {
        height: 30px;
        border: 1px solid rgba(0, 0, 0, .3);
        border-radius: 4px;
    }
}
</style>
